import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index";

import Login from '../views/Layouts/Login.vue'
import Dashboard from '../views/Dashboard/Dashboard.vue'
import YegoDashboard from '../contexts/dashboard/ui/yego_dashboard.vue'

// Fulfillment COD
import ShipmentsCodPendings from '../contexts/shipments/ui/fulfillment/cod/pendings.vue'
import ShipmentsCodInProcess from '../contexts/shipments/ui/fulfillment/cod/in_process.vue'
import ShipmentsCodSent from '../contexts/shipments/ui/fulfillment/cod/sent.vue'
import ShipmentsCodReturns from '../contexts/shipments/ui/fulfillment/cod/returned.vue'
import EditPendingShipmentCod from '../views/Fulfillment/Cod/EditPending.vue'
import EditSentShipmentCod from '../views/Fulfillment/Cod/EditSent.vue'

// Fulfillment PREPAID
import ShipmentsPrepaidPendings from '../contexts/shipments/ui/fulfillment/prepaid/pendings.vue'
import ShipmentsPrepaidInProcess from '../contexts/shipments/ui/fulfillment/prepaid/in_process.vue'
import ShipmentsPrepaidSent from '../contexts/shipments/ui/fulfillment/prepaid/sent.vue'
import ShipmentsPrepaidReturns from '../contexts/shipments/ui/fulfillment/prepaid/returned.vue'
import EditPendingShipmentPrepaid from '../views/Fulfillment/Prepaid/EditPending.vue'
import EditSentShipmentPrepaid from '../views/Fulfillment/Prepaid/EditSent.vue'

import ShipmentIncidence from '../contexts/shipments/ui/create_incidence.vue'

import WarehousesIndex from '../contexts/warehouses/ui/index.vue'
import WarehouseDetail from '../views/Warehouses/Detail.vue'
import WarehouseEdit from '../views/Warehouses/Edit.vue'
import WarehouseCreate from '../views/Warehouses/Create.vue'

import RolesIndex from '../contexts/roles/ui/index.vue'
import RolesCreate from '../contexts/roles/ui/create.vue'
import RolesEdit from '../contexts/roles/ui/edit.vue'

// Customers Views
import CustomersIndex from '../contexts/customers/ui/index.vue'
import CustomersDetail from '../views/Customers/Detail.vue'
import CustomersEdit from '../contexts/customers/ui/edit.vue'
import CustomersEditFees from '../contexts/customers/ui/edit_fees.vue'
import CustomersCreate from '../contexts/customers/ui/create.vue'
import CustomersManageStores from '../views/Customers/ManageStores.vue'
import CustomersManageSMS from '../views/Customers/ManageSMS.vue'
import CustomerEditGuidesFees from '../contexts/settings_guides/ui/edit_guides_fees.vue'

import LocationsIndex from '../contexts/locations/ui/index.vue'
import LocationsDetail from '../views/Locations/Detail.vue'
import LocationsEdit from '../views/Locations/Edit.vue'
import LocationsCreate from '../views/Locations/Create.vue'

import CategoriesIndex from '../contexts/categories/ui/index.vue'
import CategoriesDetail from '../views/Categories/Detail.vue'
import CategoriesEdit from '../views/Categories/Edit.vue'
import CategoriesCreate from '../views/Categories/Create.vue'

import CustomAgentsIndex from '../views/CustomAgents/Index.vue'
import CustomAgentsDetail from '../views/CustomAgents/Detail.vue'
import CustomAgentsEdit from '../views/CustomAgents/Edit.vue'
import CustomAgentsCreate from '../views/CustomAgents/Create.vue'

import KitsIndex from '../contexts/kits/ui/index.vue'
import KitsDetail from '../views/Kits/Detail.vue'
import KitsEdit from '../views/Kits/Edit.vue'
import KitsCreate from '../views/Kits/Create.vue'

// Inventory
import ProductsIndex from '../contexts/products/ui/index.vue'
import ProductsDetail from '../contexts/products/ui/detail.vue'
import Refurbish from '../views/Products/Refurbish.vue'
import ProductsEdit from '../views/Products/Edit.vue'
import ProductsCreate from '../views/Products/Create.vue'

import OriginSuppliersIndex from '../views/OriginSuppliers/Index.vue'
import OriginSuppliersDetail from '../views/OriginSuppliers/Detail.vue'
import OriginSuppliersEdit from '../views/OriginSuppliers/Edit.vue'
import OriginSuppliersCreate from '../views/OriginSuppliers/Create.vue'

import GatesIndex from '../contexts/gates/ui/index.vue'
import GatesCreate from '../contexts/gates/ui/create.vue'
import GatesEdit from '../contexts/gates/ui/edit.vue'

import BoxesIndex from '../contexts/boxes/ui/index.vue'
import BoxesEdit from '../views/Boxes/Edit.vue'
import BoxesCreate from '../views/Boxes/Create.vue'

import StationsIndex from '../contexts/stations/ui/index.vue'
import EditStation from '../contexts/stations/ui/edit.vue'
import CreateStation from '../contexts/stations/ui/create.vue'

import SlotsIndex from '../contexts/slots/ui/index.vue'
import CreateSlot from '../contexts/slots/ui/create.vue'

import TotesIndex from '../contexts/totes/ui/index.vue'
import CreateTote from '../contexts/totes/ui/create.vue'
import EditTote from '../contexts/totes/ui/edit.vue'

// Appointment Operations
import OperationPendings from '../contexts/appointments/ui/operation/pendings.vue'
import OperationEnterTheEnclosure from '../contexts/appointments/ui/operation/enter_the_enclosure.vue'
import OperationOnEnclosure from '../contexts/appointments/ui/operation/on_enclosure.vue'
import OperationPlaceOnRamp from '../contexts/appointments/ui/operation/place_on_ramp.vue'
import OperationOnRamp from '../contexts/appointments/ui/operation/on_ramp.vue'
import OperationStartProcessing from '../contexts/appointments/ui/operation/start_processing.vue'
import OperationInProcess from '../contexts/appointments/ui/operation/in_process.vue'
import OperationEndProcess from '../contexts/appointments/ui/operation/end_process.vue'
import OperationPendingOut from '../contexts/appointments/ui/operation/pending_out.vue'
import OperationFinish from '../contexts/appointments/ui/operation/finish.vue'

// Apointments
import NationalPendings from '../contexts/appointments/ui/national/pendings.vue'
import NationalProcessed from '../contexts/appointments/ui/national/processed.vue'
import InternationalPendings from '../contexts/appointments/ui/international/pendings.vue'
import InternationalProcessed from '../contexts/appointments/ui/international/processed.vue'
// import InternationalNoAnnex from '../views/Appointments/International/NoAnnex.vue'
// import InternationalDigitalHeritage from '../views/Appointments/International/DigitalHeritage.vue'
import ComplianceProcessed from '../views/Appointments/Compliance/Processed.vue'
import ComplianceNoAnnex from '../views/Appointments/Compliance/NoAnnex.vue'
import ComplianceDigitalHeritage from '../views/Appointments/Compliance/DigitalHeritage.vue'
import PreloadIncomeAppointment from '../views/Appointments/PreloadIncome.vue'
import PreloadOutcomeAppointment from '../views/Appointments/PreloadOutcome.vue'
import PickingAppointment from '../views/Appointments/Picking.vue'
import StoreProductIncomeAppointment from '../views/Appointments/StoreIncome.vue'
import CreateAppointment from '../views/Appointments/Create.vue'
import EditAppointment from '../views/Appointments/Edit.vue'
import AppointmentDetails from '../views/Appointments/Detail.vue'

// Yego Services
import IncidenceDetail from '../views/Appointments/Incidences/Detail.vue'
import IncidenceEdit from '../views/Appointments/Incidences/Edit.vue'
import OutcomeAppointment from '../views/Appointments/International/OutcomeAppointment.vue'
import MultipleAppointments from '../views/Appointments/International/MultipleAppointments.vue'
import CollectionIndex from '../views/YegoServices/Collection.vue'
import CreateOrder from '../views/YegoServices/CreateOrder.vue'
import CreateMultipleOrders from '../views/YegoServices/CreateMultipleOrders.vue';
import CodCollectionIndex from '../views/YegoServices/CodCollection.vue'
import UsersIndex from '../views/Access/Users/Index.vue'
import UsersCreate from '../views/Access/Users/Create.vue'
import UsersEdit from '../views/Access/Users/Edit.vue'
import AdminSearch from '../contexts/yego_services/ui/admin_search.vue'
import YegoReports from '../views/YegoServices/Reports.vue'

// Relocations
import RelocationsIndex from '../contexts/relocations/ui/index.vue'
import RelocationsCreate from '../contexts/relocations/ui/relocate.vue'
import RelocationsWithTag from '../contexts/relocations/ui/relocate_with_tag.vue'
import RelocationsAllInLocation from '../contexts/relocations/ui/relocate_all_in_location.vue'

import TaxpayerData from '../views/CustomsOperator/Catalogs/TaxpayerData.vue'
import Materials from '../views/CustomsOperator/Catalogs/Materials.vue'
import Products from '../views/CustomsOperator/Catalogs/Products.vue'
import Suppliers from '../views/CustomsOperator/Catalogs/Suppliers.vue'
import Customers from '../views/CustomsOperator/Catalogs/Customers.vue'
import Submanufacturing from '../views/CustomsOperator/Catalogs/Submanufacturing.vue'
import AgentsAndCustomAgents from '../views/CustomsOperator/Catalogs/AgentsAndCustomAgents.vue'
import FixedAssets from '../views/CustomsOperator/Catalogs/FixedAssets.vue'
import IncomingMovements from '../views/CustomsOperator/InterfacesModule/IncomingMovements.vue'
import OutcomingMovements from '../views/CustomsOperator/InterfacesModule/OutcomingMovements.vue'
import ManufacturingMovements from '../views/CustomsOperator/InterfacesModule/ManufacturingMovements.vue'
import CMIncomingMovements from '../views/CustomsOperator/CustomsModule/IncomingMovements.vue'
import CMOutcomingMovements from '../views/CustomsOperator/CustomsModule/OutcomingMovements.vue'
import CMFixedAssets from '../views/CustomsOperator/CustomsModule/FixedAssets.vue'
import RMIncomingMovements from '../views/CustomsOperator/ReportingModule/IncomingMovements.vue'
import RMOutcomingMovements from '../views/CustomsOperator/ReportingModule/OutcomingMovements.vue'
import RMBalances from '../views/CustomsOperator/ReportingModule/Balances.vue'
import RMDisclaimers from '../views/CustomsOperator/ReportingModule/Disclaimers.vue'
import RMSettings from '../views/CustomsOperator/ReportingModule/Settings.vue'
import RMExpirations from '../views/CustomsOperator/ReportingModule/Expirations.vue'

// NEW ANNEX 24 VIEWS
import TaxpayerData2 from '../views/NewAnnex24/Catalogs/TaxpayerData.vue'
import Materials2 from '../views/NewAnnex24/Catalogs/Materials.vue'
import Products2 from '../views/NewAnnex24/Catalogs/Products.vue'
import Suppliers2 from '../views/NewAnnex24/Catalogs/Suppliers.vue'
import Customers2 from '../views/NewAnnex24/Catalogs/Customers.vue'
import AgentsAndCustomAgents2 from '../views/NewAnnex24/Catalogs/AgentsAndCustomAgents.vue'
import CMIncomingMovements2 from '../views/NewAnnex24/CustomsModule/IncomingMovements.vue'
import CMMaterialLetters from '../views/NewAnnex24/CustomsModule/MaterialLetters.vue'
import CMOutcomingMovements2 from '../views/NewAnnex24/CustomsModule/OutcomingMovements.vue'
import CMFixedAssets2 from '../views/NewAnnex24/CustomsModule/FixedAssets.vue'
import RMIncomingMovements2 from '../views/NewAnnex24/ReportingModule/IncomingMovements.vue'
import RMOutcomingMovements2 from '../views/NewAnnex24/ReportingModule/OutcomingMovements.vue'
import RMBalances2 from '../views/NewAnnex24/ReportingModule/Balances.vue'
import RMDisclaimers2 from '../views/NewAnnex24/ReportingModule/Disclaimers.vue'
import RMExpirations2 from '../views/NewAnnex24/ReportingModule/Expirations.vue'
import RMUsedMaterials from '../views/NewAnnex24/ReportingModule/UsedMaterials.vue'
import Visitors from '../views/CustomsAdministrator/Visitors.vue'
import Transportation from '../views/CustomsAdministrator/Transportation.vue'

// Customers Views
import customerDashboard from '../views/CustomersRole/Dashboard.vue'
import MyInventory from '../views/CustomersRole/Inventory/MyInventory.vue'
import MyOperations from '../views/CustomersRole/Appointments/MyOperations.vue'
import CustomerProductsDetail from '../views/CustomersRole/Products/Detail.vue'
import CustomerKitsDetail from '../views/CustomersRole/Kits/Detail.vue'
import MyOrders from '../views/CustomersRole/Fulfillment/MyOrders.vue'
import MyExternalOrders from '../views/CustomersRole/Fulfillment/MyExternalOrders.vue'
import CustomerAppointmentDetails from '../views/CustomersRole/Appointments/Details.vue'
import CustomerCreateOrder from '../views/CustomersRole/Fulfillment/CreateOrder.vue'
import CustomerEditPendingOrder from '../views/CustomersRole/Fulfillment/EditPending.vue'
import CustomerUpdateLabel from '../views/CustomersRole/Fulfillment/EditOtraOrders.vue'

import StockReport from '../views/Reports/Stock.vue'
import StockWithoutLocationReport from '../views/Reports/StockWithoutLocation.vue'
import StockWithoutLocationReportCSide from '../views/Reports/StockWithoutLocationCSide.vue'
import OperationsByCustomerReport from '../views/Reports/OperationsByCustomer.vue'
import OperationsByCustomerCSideReport from '../views/Reports/OperationsByCustomerCSide.vue'
import CODByShippingServiceReport from '../views/Reports/CODByShippingService.vue'
import OperationsByProductCSideReport from '../views/Reports/OperationsByProductCSide.vue'
import OperationsByProductReport from '../views/Reports/OperationsByProduct.vue'
import InternationalOperationsReport from '../views/Reports/InternationalOperations.vue'
import ProductByFulfillmentReport from '../views/Reports/ProductByFulfillment.vue'
import ProductByFulfillmentCSideReport from '../views/Reports/ProductByFulfillmentCSide.vue'
import Annex24 from '../views/Appointments/International/MassiveAnnex.vue'
import HistoryProductReport from '../views/Reports/HistoryProduct.vue'
import FulfillmentSummary from '../views/Reports/FulfillmentSummary.vue'
import BalancePerPallet from '../views/Reports/BalancePerPallet.vue';
import BoxesPerFulfillment from '../views/Reports/BoxesPerFulfillment.vue'
import CondensedFulfillment from '../views/Reports/CondensedFulfillment.vue';

import OrdersPendingsIndex from '../views/StuckOrders/Index.vue'
import OrdersPendingsComplete from '../views/StuckOrders/Create.vue'
import StuckExternalOrdersIndex from '../views/StuckExternalOrders/Index.vue'
import StuckExternalOrdersEdit from '../views/StuckExternalOrders/Edit.vue'

import OrdersPossibleFraudIndex from '../views/OrdersPossibleFraud/Index.vue'
import OrdersPossibleFraudComplete from '../views/OrdersPossibleFraud/Create.vue'

import LiverpoolAcceptance from '../views/Liverpool/Acceptance.vue'
import LiverpoolConfirmation from '../views/Liverpool/Confirmation.vue'
import LiverpoolHistory from '../views/Liverpool/History.vue'
import ProductByOrder from '../views/Reports/ProductByOrder.vue'
import AnnexDocuments from '../views/Reports/AnnexDocuments.vue'

//Customs Patches
import CustomsPatchesIndex from '../views/CustomsPatches/Index.vue';
import CustomsPatchesDetail from '../views/CustomsPatches/Detail.vue';
import CustomsPatchesDischargesReport from '../views/CustomsPatches/Reports/DischargesReport.vue';
import CustomsPatchesBalanceReport from '../views/CustomsPatches/Reports/BalanceReport.vue';
import CustomsPatchesExpirationReport from '../views/CustomsPatches/Reports/ExpirationReport.vue';

// Appointment Services
import ServicesIndex from '../views/AppointmentServices/Index.vue';
import ServicesCreate from '../views/AppointmentServices/Create.vue';
import ServicesEdit from '../views/AppointmentServices/Edit.vue'

// Backlog
import Backlog from '../contexts/backlog/ui/index.vue'

// Track And Trace
import ExtraStatus from '../views/TrackNTrace/ExtraStatus.vue'
import Delivered from '../views/TrackNTrace/Delivered.vue'
import DeliveredDetails from '../views/TrackNTrace/DeliveredDetails.vue'
import WithoutMovement from '../views/TrackNTrace/WithoutMovement.vue'
import DailyCutoff from '../views/TrackNTrace/DailyCutoff.vue'
import Rejections from '../views/TrackNTrace/Rejections.vue'
import ClosingMinute from '../views/TrackNTrace/ClosingMinute.vue'

// Entrance
import VisitorsIndex from '../views/Entrance/Visitors/Index.vue'
import VisitorsCreate from '../views/Entrance/Visitors/Create.vue'
import VisitorsCreateSchedule from '../views/Entrance/Visitors/ScheduledCreate.vue'
import VisitorsEdit from '../views/Entrance/Visitors/Edit.vue'
import VisitorsDetail from '../views/Entrance/Visitors/Detail.vue'
import CarriersIndex from '../views/Entrance/Carriers/Index.vue'
import CarriersEdit from '../views/Entrance/Carriers/Edit.vue'
import CarriersCreate from '../views/Entrance/Carriers/Create.vue'
import CarriersDetail from '../views/Entrance/Carriers/Detail.vue'
import AttendancesIndex from '../views/Entrance/Attendances/Index.vue'

// Advanced Fulfillment External Shipments
import EAFPendings from '../contexts/external_shipments/ui/advanced_fulfillment/pendings.vue'
import EAFPrepare from '../contexts/external_shipments/ui/advanced_fulfillment/prepare.vue'
import EAFFToBeSupplied from '../contexts/external_shipments/ui/advanced_fulfillment/to_be_supplied.vue'
import EAFFSupply from '../contexts/external_shipments/ui/advanced_fulfillment/supply.vue'
import EAFFSupplied from '../contexts/external_shipments/ui/advanced_fulfillment/supplied.vue'
import EAFFSent from '../contexts/external_shipments/ui/advanced_fulfillment/sent.vue'
import EAFFReturned from '../contexts/external_shipments/ui/advanced_fulfillment/returned.vue'

// Advanced Fulfillment Shipments
import AFPendings from '../contexts/shipments/ui/advanced_fulfillment/pendings.vue'
import AFPrepare from '../contexts/shipments/ui/advanced_fulfillment/prepare.vue'
import AFToBeSupplied from '../contexts/shipments/ui/advanced_fulfillment/to_be_supplied.vue'
import AFFSupply from '../contexts/shipments/ui/advanced_fulfillment/supply.vue'
import AFSupplied from '../contexts/shipments/ui/advanced_fulfillment/supplied.vue'
import AFSent from '../contexts/shipments/ui/advanced_fulfillment/sent.vue'
import AFReturns from '../contexts/shipments/ui/advanced_fulfillment/returned.vue'

// Fulfillment PTL
import PendingsPtl from '../contexts/shipments/ui/fulfillment_ptl/pendings.vue'
import PreparePtl from '../contexts/shipments/ui/fulfillment_ptl/prepare.vue'
import ToBeSuppliedPtl from '../contexts/shipments/ui/fulfillment_ptl/to_be_supplied.vue'
import SuppliedPtl from '../contexts/shipments/ui/fulfillment_ptl/supplied.vue'
import SentPtl from '../contexts/shipments/ui/fulfillment_ptl/sent.vue'
import ReturnsPtl from '../contexts/shipments/ui/fulfillment_ptl/returns.vue'
import AssemblePtl from '../contexts/shipments/ui/fulfillment_ptl/assemble.vue'

// Fulfillment EON
import PendingsEon from '../views/FulfillmentEon/Pendings.vue'
import CreateWithLabel from '../contexts/external_shipments/ui/create_with_label.vue'
import InProcessEon from '../views/FulfillmentEon/InProcess.vue'
import SentEon from '../views/FulfillmentEon/Sent.vue'
import ReturnsEon from '../views/FulfillmentEon/Returns.vue'
import EditPendigEon from '../views/FulfillmentEon/EditPending.vue'

// Fulfillment Leirem
import PendingsLeirem from '../views/FulfillmentLeirem/Pendings.vue'
import InProcessLeirem from '../views/FulfillmentLeirem/InProcess.vue'
import SentLeirem from '../views/FulfillmentLeirem/Sent.vue'
import PrepareLeirem from '../views/FulfillmentLeirem/Prepare.vue'

// Basic Search
import BasicSearch from '../contexts/yego_services/ui/basic_search.vue'

// Consumables 
import ConsumablesIndex from '../views/Consumables/Index.vue'
import ConsumablesCreate from '../views/Consumables/Create.vue'

// Guides
import Guides from '../contexts/guides/ui/index.vue'
import GuideDetail from '../contexts/guides/ui/details.vue'
import GuideSales from '../contexts/guides/ui/sales.vue'
import GuidesCustomerSide from '../contexts/guides/ui/customer_side/index.vue'

// Pickup Addresses
import PickupAddressesCustomerSide from '../contexts/pickup_addresses/ui/customer_side/index.vue'

Vue.use(VueRouter)

const routes = [
  // { path: '/', redirect: '/login' },
  {
    path: '*',
    redirect: function () {
      if (store.state.clientUserId != null && store.state.clientUserId != undefined) return '/customerDashboard';
      else return '/dashboard';
    }
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: 'Chronos - Inicio de sesión',
      auth: false,
    },
    component: Login
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      title: 'Chronos - Dashboard',
      auth: true,
    },
    component: Dashboard
  },
  {
    path: '/yego_dashboard',
    name: 'Yego Dashboard',
    meta: {
      title: 'Chronos - Yego Dashboard',
      auth: true,
    },
    component: YegoDashboard
  },
  {
    path: '/national-pendings/:m_type',
    name: 'NationalPendings',
    meta: {
      title: 'Chronos - Pendientes',
      auth: true,
    },
    component: NationalPendings
  },
  {
    path: '/national-processed/:m_type',
    name: 'NationalProcessed',
    meta: {
      title: 'Chronos - Procesadas',
      auth: true,
    },
    component: NationalProcessed
  },
  {
    path: '/international-pendings/:m_type',
    name: 'InternationalPendings',
    meta: {
      title: 'Chronos - Pendientes',
      auth: true,
    },
    component: InternationalPendings
  },
  {
    path: '/international-processed/:m_type',
    name: 'InternationalProcessed',
    meta: {
      title: 'Chronos - Procesadas',
      auth: true,
    },
    component: InternationalProcessed
  },
  {
    path: '/compliance-processed',
    name: 'ComplianceProcessed',
    meta: {
      title: 'Chronos - Procesadas',
      auth: true,
    },
    component: ComplianceProcessed
  },
  {
    path: '/compliance-no-annex',
    name: 'ComplianceNoAnnex',
    meta: {
      title: 'Chronos - Sin Anexo 24',
      auth: true,
    },
    component: ComplianceNoAnnex
  },
  {
    path: '/compliance-digital-heritage',
    name: 'ComplianceDigitalHeritage',
    meta: {
      title: 'Chronos - Acervo Digital',
      auth: true,
    },
    component: ComplianceDigitalHeritage
  },
  {
    path: '/create-appointment/:from/:m_type',
    name: 'Create_appointment',
    meta: {
      title: 'Chronos - Crear Cita',
      auth: true,
    },
    component: CreateAppointment
  },
  {
    path: '/edit-appointment/:id/:from/:m_type',
    name: 'Edit_appointment',
    meta: {
      title: 'Chronos - Editar Cita',
      auth: true,
    },
    component: EditAppointment
  },
  {
    path: '/appointment-preload-income/:id/:from/:m_type',
    name: 'PreloadIncomeAppointment',
    meta: {
      title: 'Chronos - Pre-captura Cita',
      auth: true,
    },
    component: PreloadIncomeAppointment
  },
  {
    path: '/appointment-preload-outcome/:id/:from/:m_type',
    name: 'PreloadOutcomeAppointment',
    meta: {
      title: 'Chronos - Pre-captura Cita',
      auth: true,
    },
    component: PreloadOutcomeAppointment
  },
  {
    path: '/appointment-picking/:id',
    name: 'PickingAppointment',
    meta: {
      title: 'Chronos - Pickeo de Cita',
      auth: true,
    },
    component: PickingAppointment
  },
  {
    path: '/appointment-store-product-income/:id/:from',
    name: 'StoreProductIncomeAppointment',
    meta: {
      title: 'Chronos - Almacenar Producto',
      auth: true,
    },
    component: StoreProductIncomeAppointment
  },
  {
    path: '/appointment-details/:id/:from',
    name: 'Appointment_Details',
    meta: {
      title: 'Chronos - Detalles de Cita',
      auth: true,
    },
    component: AppointmentDetails
  },
  {
    path: '/roles/create',
    name: 'RolesCreate',
    meta: {
      title: 'Chronos - Roles - Nuevo Rol',
      auth: true,
    },
    component: RolesCreate
  },
  {
    path: '/roles/edit/:id',
    name: 'RolesEdit',
    meta: {
      title: 'Chronos - Roles - Editar Rol',
      auth: true,
    },
    component: RolesEdit
  },
  {
    path: '/roles',
    name: 'RolesIndex',
    meta: {
      title: 'Chronos - Roles',
      auth: true,
    },
    component: RolesIndex
  },
  {
    path: '/shipments/:shipping_service/pendings/cod',
    name: 'ShipmentsCodPendings',
    meta: {
      title: 'Chronos - Ordenes Pendientes',
      auth: true,
    },
    component: ShipmentsCodPendings
  },
  {
    path: '/shipments/:shipping_service/in-process/cod',
    name: 'ShipmentsCodInProcess',
    meta: {
      title: 'Chronos - Ordenes En Proceso',
      auth: true,
    },
    component: ShipmentsCodInProcess
  },
  {
    path: '/shipments/:shipping_service/sent/cod',
    name: 'ShipmentsCodSent',
    meta: {
      title: 'Chronos - Ordenes Enviadas',
      auth: true,
    },
    component: ShipmentsCodSent
  },
  {
    path: '/shipments/:shipping_service/returns/cod',
    name: 'ShipmentsCodReturns',
    meta: {
      title: 'Chronos - Ordenes Retornadas',
      auth: true,
    },
    component: ShipmentsCodReturns
  },
  {
    path: '/pending-shipments/cod/edit/:id',
    name: 'EditPendingShipmentCod',
    meta: {
      title: 'Chronos - Editar Orden COD',
      auth: true,
    },
    component: EditPendingShipmentCod
  },
  {
    path: '/sent-shipments/cod/edit/:id',
    name: 'EditSentShipmentCod',
    meta: {
      title: 'Chronos - Editar Orden Enviada COD',
      auth: true,
    },
    component: EditSentShipmentCod
  },
  {
    path: '/shipments/:shipping_service/pendings/prepaid',
    name: 'ShipmentsPrepaidPendings',
    meta: {
      title: 'Chronos - Ordenes Pendientes',
      auth: true,
    },
    component: ShipmentsPrepaidPendings
  },
  {
    path: '/shipments/:shipping_service/in-process/prepaid',
    name: 'ShipmentsPrepaidInProcess',
    meta: {
      title: 'Chronos - Ordenes En Proceso',
      auth: true,
    },
    component: ShipmentsPrepaidInProcess
  },
  {
    path: '/shipments/:shipping_service/sent/prepaid',
    name: 'ShipmentsPrepaidSent',
    meta: {
      title: 'Chronos - Ordenes Enviadas',
      auth: true,
    },
    component: ShipmentsPrepaidSent
  },
  {
    path: '/shipments/:shipping_service/returns/prepaid',
    name: 'ShipmentsPrepaidReturns',
    meta: {
      title: 'Chronos - Ordenes Retornadas',
      auth: true,
    },
    component: ShipmentsPrepaidReturns
  },
  {
    path: '/pending-shipments/prepaid/edit/:id',
    name: 'EditPendingShipmentPrepaid',
    meta: {
      title: 'Chronos - Editar Orden Prepago',
      auth: true,
    },
    component: EditPendingShipmentPrepaid
  },
  {
    path: '/sent-shipments/prepaid/edit/:id',
    name: 'EditSentShipmentPrepago',
    meta: {
      title: 'Chronos - Editar Orden Enviada Prepago',
      auth: true,
    },
    component: EditSentShipmentPrepaid
  },

  {
    path: '/shipments/:type/incidence/:id',
    name: 'ShipmentIncidence',
    meta: {
      title: 'Chronos - Retornos Incidencias',
      auth: true,
    },
    component: ShipmentIncidence
  },

  {
    path: '/warehouses',
    name: 'WarehousesIndex',
    meta: {
      title: 'Chronos - Almacenes',
      auth: true,
    },
    component: WarehousesIndex
  },
  {
    path: '/warehouses/details/:id',
    name: 'WarehouseDetail',
    meta: {
      title: 'Chronos - Almacenes - Detalle',
      auth: true,
    },
    component: WarehouseDetail
  },
  {
    path: '/warehouses/edit/:id',
    name: 'WarehouseEdit',
    meta: {
      title: 'Chronos - Almacenes - Editar',
      auth: true,
    },
    component: WarehouseEdit
  },
  {
    path: '/warehouses/create',
    name: 'WarehouseCreate',
    meta: {
      title: 'Chronos - Almacenes - Nuevo Almacen',
      auth: true,
    },
    component: WarehouseCreate
  },
  {
    path: '/customers',
    name: 'CustomersIndex',
    meta: {
      title: 'Chronos - Clientes',
      auth: true,
    },
    component: CustomersIndex
  },
  {
    path: '/customers/details/:id',
    name: 'CustomersDetail',
    meta: {
      title: 'Chronos - Clientes - Detalle',
      auth: true,
    },
    component: CustomersDetail
  },
  {
    path: '/customers/edit/:id',
    name: 'CustomersEdit',
    meta: {
      title: 'Chronos - Clientes - Editar',
      auth: true,
    },
    component: CustomersEdit
  },
  {
    path: '/customers/edit/fees/:id',
    name: 'CustomersEditFees',
    meta: {
      title: 'Chronos - Clientes - Editar Cuotas',
      auth: true,
    },
    component: CustomersEditFees
  },
  {
    path: '/Customers/create',
    name: 'CustomersCreate',
    meta: {
      title: 'Chronos - Clientes - Nuevo Cliente',
      auth: true,
    },
    component: CustomersCreate
  },
  {
    path: '/customers/manage_stores/:id',
    name: 'CustomersManageStores',
    meta: {
      title: 'Chronos - Clientes - Administrar Tiendas',
      auth: true,
    },
    component: CustomersManageStores
  },
  {
    path: '/customers/manage_sms/:id',
    name: 'CustomersManageSMS',
    meta: {
      title: 'Chronos - Clientes - Configurar SMS',
      auth: true,
    },
    component: CustomersManageSMS
  },
  {
    path: '/locations',
    name: 'LocationsIndex',
    meta: {
      title: 'Chronos - Ubicaciones',
      auth: true,
    },
    component: LocationsIndex
  },
  {
    path: '/locations/details/:id',
    name: 'LocationsDetail',
    meta: {
      title: 'Chronos - Ubicaciones - Detalle',
      auth: true,
    },
    component: LocationsDetail
  },
  {
    path: '/locations/edit/:id',
    name: 'LocationsEdit',
    meta: {
      title: 'Chronos - Ubicaciones - Editar',
      auth: true,
    },
    component: LocationsEdit
  },
  {
    path: '/locations/create',
    name: 'LocationsCreate',
    meta: {
      title: 'Chronos - Ubicaciones - Nueva Ubicación',
      auth: true,
    },
    component: LocationsCreate
  },
  {
    path: '/categories',
    name: 'CategoriesIndex',
    meta: {
      title: 'Chronos - Categorias',
      auth: true,
    },
    component: CategoriesIndex
  },
  {
    path: '/categories/details/:id',
    name: 'CategoriesDetail',
    meta: {
      title: 'Chronos - Categorias - Detalle',
      auth: true,
    },
    component: CategoriesDetail
  },
  {
    path: '/categories/edit/:id',
    name: 'CategoriesEdit',
    meta: {
      title: 'Chronos - Categorias - Editar',
      auth: true,
    },
    component: CategoriesEdit
  },
  {
    path: '/categories/create',
    name: 'CategoriesCreate',
    meta: {
      title: 'Chronos - Categorías - Nueva Categoría',
      auth: true,
    },
    component: CategoriesCreate
  },
  {
    path: '/custom-agents',
    name: 'CustomAgentsIndex',
    meta: {
      title: 'Chronos - Agentes Aduanales',
      auth: true,
    },
    component: CustomAgentsIndex
  },
  {
    path: '/custom-agents/details/:id',
    name: 'CustomAgentsDetail',
    meta: {
      title: 'Chronos - Agentes Aduanales - Detalle',
      auth: true,
    },
    component: CustomAgentsDetail
  },
  {
    path: '/custom-agents/edit/:id',
    name: 'CustomAgentsEdit',
    meta: {
      title: 'Chronos - Agentes Aduanales - Editar',
      auth: true,
    },
    component: CustomAgentsEdit
  },
  {
    path: '/custom-agents/create',
    name: 'CustomAgentsCreate',
    meta: {
      title: 'Chronos - Agentes Aduanales - Nueva Agente Aduanal',
      auth: true,
    },
    component: CustomAgentsCreate
  },
  {
    path: '/kits',
    name: 'KitsIndex',
    meta: {
      title: 'Chronos - Kits',
      auth: true,
    },
    component: KitsIndex
  },
  {
    path: '/kits/details/:id',
    name: 'KitsDetail',
    meta: {
      title: 'Chronos - Kits - Detalle',
      auth: true,
    },
    component: KitsDetail
  },
  {
    path: '/kits/edit/:id',
    name: 'KitsEdit',
    meta: {
      title: 'Chronos - Kits - Editar',
      auth: true,
    },
    component: KitsEdit
  },
  {
    path: '/kits/create',
    name: 'KitsCreate',
    meta: {
      title: 'Chronos - Kits - Nuevo Kit',
      auth: true,
    },
    component: KitsCreate
  },
  {
    path: '/products',
    name: 'ProductsIndex',
    meta: {
      title: 'Chronos - Productos',
      auth: true,
    },
    component: ProductsIndex
  },
  {
    path: '/products/details/:id',
    name: 'ProductsDetail',
    meta: {
      title: 'Chronos - Productos - Detalle',
      auth: true,
    },
    component: ProductsDetail
  },
  {
    path: '/products/refurbish/:id',
    name: 'Refurbish',
    meta: {
      title: 'Chronos - Productos - Reacondicionar',
      auth: true,
    },
    component: Refurbish
  },
  {
    path: '/products/edit/:id',
    name: 'ProductsEdit',
    meta: {
      title: 'Chronos - Productos - Editar',
      auth: true,
    },
    component: ProductsEdit
  },
  {
    path: '/products/create',
    name: 'ProductsCreate',
    meta: {
      title: 'Chronos - Productos - Nuevo Producto',
      auth: true,
    },
    component: ProductsCreate
  },
  {
    path: '/origin-suppliers',
    name: 'OriginSuppliersIndex',
    meta: {
      title: 'Chronos - Proveedores de Origen',
      auth: true,
    },
    component: OriginSuppliersIndex
  },
  {
    path: '/origin-suppliers/details/:id',
    name: 'OriginSuppliersDetail',
    meta: {
      title: 'Chronos - Proveedores de Origen - Detalle',
      auth: true,
    },
    component: OriginSuppliersDetail
  },
  {
    path: '/origin-suppliers/edit/:id',
    name: 'OriginSuppliersEdit',
    meta: {
      title: 'Chronos - Proveedores de Origen - Editar',
      auth: true,
    },
    component: OriginSuppliersEdit
  },
  {
    path: '/origin-suppliers/create',
    name: 'OriginSuppliersCreate',
    meta: {
      title: 'Chronos - Proveedores de Origen - Nuevo Proveedor de Origen',
      auth: true,
    },
    component: OriginSuppliersCreate
  },
  {
    path: '/gates',
    name: 'GatesIndex',
    meta: {
      title: 'Chronos - Puertas',
      auth: true,
    },
    component: GatesIndex
  },
  {
    path: '/gates/edit/:id',
    name: 'GatesEdit',
    meta: {
      title: 'Chronos - Puertas - Editar',
      auth: true,
    },
    component: GatesEdit
  },
  {
    path: '/gates/create',
    name: 'GatesCreate',
    meta: {
      title: 'Chronos - Puertas - Nueva Puerta',
      auth: true,
    },
    component: GatesCreate
  },
  {
    path: '/boxes',
    name: 'BoxesIndex',
    meta: {
      title: 'Chronos - Cajas',
      auth: true,
    },
    component: BoxesIndex
  },
  {
    path: '/boxes/edit/:id',
    name: 'BoxesEdit',
    meta: {
      title: 'Chronos - Cajas - Editar',
      auth: true,
    },
    component: BoxesEdit
  },
  {
    path: '/boxes/create',
    name: 'BoxesCreate',
    meta: {
      title: 'Chronos - Cajas - Nueva Caja',
      auth: true,
    },
    component: BoxesCreate
  },
  {
    path: '/operation/pendings/:from/:m_type',
    name: 'OperationPendings',
    meta: {
      title: 'Chronos - Operaciones - Pendientes',
      auth: true,
    },
    component: OperationPendings
  },
  {
    path: '/operation/enter-the-enclosure/:id/:from/:m_type',
    name: 'OperationEnterTheEnclosure',
    meta: {
      title: 'Chronos - Operaciones - Procesar Pendiente',
      auth: true,
    },
    component: OperationEnterTheEnclosure
  },
  {
    path: '/operation/on-enclosure/:from/:m_type',
    name: 'OperationOnEnclosure',
    meta: {
      title: 'Chronos - Operaciones - En patio',
      auth: true,
    },
    component: OperationOnEnclosure
  },
  {
    path: '/operation/on-ramp/:from/:m_type',
    name: 'OperationOnRamp',
    meta: {
      title: 'Chronos - Operaciones - En rampa',
      auth: true,
    },
    component: OperationOnRamp
  },
  {
    path: '/operation/place-on-ramp/:id/:from/:m_type',
    name: 'OperationPlaceOnRamp',
    meta: {
      title: 'Chronos - Operaciones - Poner en Portal',
      auth: true,
    },
    component: OperationPlaceOnRamp
  },
  {
    path: '/operation/start-processing/:id/:from/:m_type',
    name: 'OperationStartProcessing',
    meta: {
      title: 'Chronos - Operaciones - Procesar',
      auth: true,
    },
    component: OperationStartProcessing
  },
  {
    path: '/operation/in-process/:from/:m_type',
    name: 'OperationInProcess',
    meta: {
      title: 'Chronos - Operaciones - En Proceso',
      auth: true,
    },
    component: OperationInProcess
  },
  {
    path: '/operation/end-process/:id/:from/:m_type',
    name: 'OperationEndProcess',
    meta: {
      title: 'Chronos - Operaciones - Terminar Proceso',
      auth: true,
    },
    component: OperationEndProcess
  },
  {
    path: '/operation/pending-out/:from/:m_type',
    name: 'OperationPendingOut',
    meta: {
      title: 'Chronos - Operaciones - Pendiente de Salida',
      auth: true,
    },
    component: OperationPendingOut
  },
  {
    path: '/operation/finish/:id/:from/:m_type',
    name: 'OperationFinish',
    meta: {
      title: 'Chronos - Operaciones - Registrar Salida',
      auth: true,
    },
    component: OperationFinish
  },
  {
    path: '/incidence_detail/:id',
    name: 'IncidenceDetail',
    meta: {
      title: 'Chronos - Citas - Incidencia',
      auth: true,
    },
    component: IncidenceDetail
  },
  {
    path: '/incidence_edit/:id',
    name: 'IncidenceEdit',
    meta: {
      title: 'Chronos - Citas - Editar Incidencia',
      auth: true,
    },
    component: IncidenceEdit
  },
  {
    path: '/outcome_appointment/:id',
    name: 'OutcomeAppointment',
    meta: {
      title: 'Chronos - Citas - Crossdock Documental Salida',
      auth: true,
    },
    component: OutcomeAppointment
  },
  {
    path: '/upload-multiple-appointments',
    name: 'MultipleAppointments',
    meta: {
      title: 'Chronos - Citas - Multiple',
      auth: true,
    },
    component: MultipleAppointments
  },
  {
    path: '/collection',
    name: 'CollectionIndex',
    meta: {
      title: 'Chronos - Cobranza',
      auth: true,
    },
    component: CollectionIndex
  },
  {
    path: '/cod-collection',
    name: 'CodCollectionIndex',
    meta: {
      title: 'Chronos - Recolección COD',
      auth: true,
    },
    component: CodCollectionIndex
  },
  {
    path: '/users',
    name: 'UsersIndex',
    meta: {
      title: 'Chronos - Usuarios',
      auth: true,
    },
    component: UsersIndex
  },
  {
    path: '/users/create',
    name: 'UsersCreate',
    meta: {
      title: 'Chronos - Usuarios - Nuevo Usuario',
      auth: true,
    },
    component: UsersCreate
  },
  {
    path: '/users/edit/:id',
    name: 'UsersEdit',
    meta: {
      title: 'Chronos - Usuarios - Editar Usuario',
      auth: true,
    },
    component: UsersEdit
  },
  {
    path: '/search',
    name: 'AdminSearch',
    meta: {
      title: 'Chronos - Busqueda - Buscar Orden',
      auth: true,
    },
    component: AdminSearch
  },
  {
    path: '/yego-reports',
    name: 'YegoReports',
    meta: {
      title: 'Chronos - Reportes Yego',
      auth: true,
    },
    component: YegoReports
  },
  {
    path: '/relocations',
    name: 'RelocationsIndex',
    meta: {
      title: 'Chronos - Reubicación',
      auth: true,
    },
    component: RelocationsIndex
  },
  {
    path: '/relocations/create',
    name: 'RelocationsCreate',
    meta: {
      title: 'Chronos - Reubicaciones - Nueva Reubicación',
      auth: true,
    },
    component: RelocationsCreate
  },
  {
    path: '/relocations/all_in_location',
    name: 'RelocationsAllInLocation',
    meta: {
      title: 'Chronos - Reubicación',
      auth: true,
    },
    component: RelocationsAllInLocation
  },
  {
    path: '/relocations/create_with_scanner',
    name: 'RelocationsWithTag',
    meta: {
      title: 'Chronos - Reubicaciones - Nueva Reubicación',
      auth: true,
    },
    component: RelocationsWithTag
  },
  {
    path: '/customs_data/taxpayer_data',
    name: 'TaxpayerData',
    meta: {
      title: 'Operador Aduanal - Catálogos - Datos del Contribuyente',
      auth: true,
    },
    component: TaxpayerData
  },
  {
    path: '/customs_data/materials',
    name: 'Materials',
    meta: {
      title: 'Operador Aduanal - Catálogos - Materiales',
      auth: true,
    },
    component: Materials
  },
  {
    path: '/customs_data/finished_product',
    name: 'Products',
    meta: {
      title: 'Operador Aduanal - Catálogos - Productos',
      auth: true,
    },
    component: Products
  },
  {
    path: '/customs_data/suppliers',
    name: 'Suppliers',
    meta: {
      title: 'Operador Aduanal - Catálogos - Proveedores',
      auth: true,
    },
    component: Suppliers
  },
  {
    path: '/customs_data/customers',
    name: 'Customers',
    meta: {
      title: 'Operador Aduanal - Catálogos - Clientes',
      auth: true,
    },
    component: Customers
  },
  {
    path: '/customs_data/submanufacturing',
    name: 'Submanufacturing',
    meta: {
      title: 'Operador Aduanal - Catálogos - Submanufactura/Submaquila',
      auth: true,
    },
    component: Submanufacturing
  },
  {
    path: '/customs_data/agents_and_customs_agents',
    name: 'AgentsAndCustomAgents',
    meta: {
      title: 'Operador Aduanal - Catálogos - Agentes/Agentes Aduanales',
      auth: true,
    },
    component: AgentsAndCustomAgents
  },
  {
    path: '/customs_data/fixed_assets',
    name: 'FixedAssets',
    meta: {
      title: 'Operador Aduanal - Catálogos - Activos Fijos',
      auth: true,
    },
    component: FixedAssets
  },
  {
    path: '/customs_data/incoming_movements',
    name: 'IncomingMovements',
    meta: {
      title: 'Operador Aduanal - Módulo de Interfacez - Entradas',
      auth: true,
    },
    component: IncomingMovements
  },
  {
    path: '/customs_data/outcoming_movements',
    name: 'OutcomingMovements',
    meta: {
      title: 'Operador Aduanal - Módulo de Interfacez - Salidas',
      auth: true,
    },
    component: OutcomingMovements
  },
  {
    path: '/customs_data/manufacturing_movements',
    name: 'ManufacturingMovements',
    meta: {
      title: 'Operador Aduanal - Módulo de Interfacez - Movimientos de Manufactura',
      auth: true,
    },
    component: ManufacturingMovements
  },
  {
    path: '/customs_data/cm_incoming_movements',
    name: 'CMIncomingMovements',
    meta: {
      title: 'Operador Aduanal - Módulo de Aduanas - Entradas',
      auth: true,
    },
    component: CMIncomingMovements
  },
  {
    path: '/customs_data/cm_outcoming_movements',
    name: 'CMOutcomingMovements',
    meta: {
      title: 'Operador Aduanal - Módulo de Aduanas - Salidas',
      auth: true,
    },
    component: CMOutcomingMovements
  },
  {
    path: '/customs_data/cm_fixed_assets',
    name: 'CMFixedAssets',
    meta: {
      title: 'Operador Aduanal - Módulo de Aduanas - Activo Fijo',
      auth: true,
    },
    component: CMFixedAssets
  },
  {
    path: '/customs_data/rm_incoming_movements',
    name: 'RMIncomingMovements',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Entradas',
      auth: true,
    },
    component: RMIncomingMovements
  },
  {
    path: '/customs_data/rm_outcoming_movements',
    name: 'RMOutcomingMovements',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Salidas',
      auth: true,
    },
    component: RMOutcomingMovements
  },
  {
    path: '/customs_data/rm_balances',
    name: 'RMBalances',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Saldos',
      auth: true,
    },
    component: RMBalances
  },
  {
    path: '/customs_data/rm_disclaimers',
    name: 'RMDisclaimers',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Descargos',
      auth: true,
    },
    component: RMDisclaimers
  },
  {
    path: '/customs_data/rm_settings',
    name: 'RMSettings',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Ajustes',
      auth: true,
    },
    component: RMSettings
  },
  {
    path: '/customs_data/rm_expiration',
    name: 'RMExpirations',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Vencimientos',
      auth: true,
    },
    component: RMExpirations
  },
  {
    path: '/annex_24/taxpayer_data',
    name: 'TaxpayerData2',
    meta: {
      title: 'Operador Aduanal - Catálogos - Datos del Contribuyente',
      auth: true,
    },
    component: TaxpayerData2
  },
  {
    path: '/annex_24/materials',
    name: 'Materials2',
    meta: {
      title: 'Operador Aduanal - Catálogos - Materiales',
      auth: true,
    },
    component: Materials2
  },
  {
    path: '/annex_24/finished_product',
    name: 'Products2',
    meta: {
      title: 'Operador Aduanal - Catálogos - Productos',
      auth: true,
    },
    component: Products2
  },
  {
    path: '/annex_24/suppliers',
    name: 'Suppliers2',
    meta: {
      title: 'Operador Aduanal - Catálogos - Proveedores',
      auth: true,
    },
    component: Suppliers2
  },
  {
    path: '/annex_24/customers',
    name: 'Customers2',
    meta: {
      title: 'Operador Aduanal - Catálogos - Clientes',
      auth: true,
    },
    component: Customers2
  },
  {
    path: '/annex_24/agents_and_customs_agents',
    name: 'AgentsAndCustomAgents2',
    meta: {
      title: 'Operador Aduanal - Catálogos - Agentes/Agentes Aduanales',
      auth: true,
    },
    component: AgentsAndCustomAgents2
  },
  {
    path: '/annex_24/cm_incoming_movements',
    name: 'CMIncomingMovements2',
    meta: {
      title: 'Operador Aduanal - Módulo de Aduanas - Entradas',
      auth: true,
    },
    component: CMIncomingMovements2
  },
  {
    path: '/annex_24/cm_material_letters',
    name: 'CMMaterialLetters',
    meta: {
      title: 'Operador Aduanal - Módulo de Aduanas - Cartas de Materiales',
      auth: true,
    },
    component: CMMaterialLetters
  },
  {
    path: '/annex_24/cm_outcoming_movements',
    name: 'CMOutcomingMovements2',
    meta: {
      title: 'Operador Aduanal - Módulo de Aduanas - Salidas',
      auth: true,
    },
    component: CMOutcomingMovements2
  },
  {
    path: '/annex_24/cm_fixed_assets',
    name: 'CMFixedAssets2',
    meta: {
      title: 'Operador Aduanal - Módulo de Aduanas - Activo Fijo',
      auth: true,
    },
    component: CMFixedAssets2
  },
  {
    path: '/annex_24/rm_incoming_movements',
    name: 'RMIncomingMovements2',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Entradas',
      auth: true,
    },
    component: RMIncomingMovements2
  },
  {
    path: '/annex_24/rm_outcoming_movements',
    name: 'RMOutcomingMovements2',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Salidas',
      auth: true,
    },
    component: RMOutcomingMovements2
  },
  {
    path: '/annex_24/rm_balances',
    name: 'RMBalances2',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Saldos',
      auth: true,
    },
    component: RMBalances2
  },
  {
    path: '/annex_24/rm_disclaimers',
    name: 'RMDisclaimers2',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Descargos',
      auth: true,
    },
    component: RMDisclaimers2
  },
  {
    path: '/annex_24/rm_expiration',
    name: 'RMExpirations2',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Vencimientos',
      auth: true,
    },
    component: RMExpirations2
  },
  {
    path: '/annex_24/rm_used_materials',
    name: 'RMUsedMaterials',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Materiales usados',
      auth: true,
    },
    component: RMUsedMaterials
  },
  {
    path: '/customs_data/visitors',
    name: 'Visitors',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Visitantes',
      auth: true,
    },
    component: Visitors
  },
  {
    path: '/customs_data/transportation',
    name: 'Transportation',
    meta: {
      title: 'Operador Aduanal - Módulo de Reportes - Transporte E/S',
      auth: true,
    },
    component: Transportation
  },
  {
    path: '/customerDashboard',
    name: 'customerDashboard',
    meta: {
      title: 'home',
      auth: true,
    },
    component: customerDashboard
  },
  {
    path: '/customer_kits_details/:id',
    name: 'CustomerKitsDetail',
    meta: {
      title: 'Kits - Detalles',
      auth: true,
    },
    component: CustomerKitsDetail
  },
  {
    path: '/customer_products_details/:id',
    name: 'CustomerProductsDetail',
    meta: {
      title: 'Productos - Detalles',
      auth: true,
    },
    component: CustomerProductsDetail
  },
  {
    path: '/customer_appointments',
    name: 'MyOperations',
    meta: {
      title: 'Citas',
      auth: true,
    },
    component: MyOperations
  },
  {
    path: '/my_inventory',
    name: 'MyInventory',
    meta: {
      title: 'Inventario',
      auth: true,
    },
    component: MyInventory
  },
  {
    path: '/my_orders',
    name: 'MyOrders',
    meta: {
      title: 'Ordenes',
      auth: true,
    },
    component: MyOrders
  },
  {
    path: '/my_eorders',
    name: 'MyExternalOrders',
    meta: {
      title: 'Ordenes',
      auth: true,
    },
    component: MyExternalOrders
  },
  {
    path: '/customer_appointment_details/:id/:from',
    name: 'CustomerAppointmentDetails',
    meta: {
      title: 'Cita - Detalles',
      auth: true,
    },
    component: CustomerAppointmentDetails
  },

  {
    path: '/customer_fulfillment_create_order',
    name: 'CustomerCreateOrder',
    meta: {
      title: 'Crear Nueva Orden',
      auth: true,
    },
    component: CustomerCreateOrder
  },
  {
    path: '/create_order',
    name: 'CreateOrder',
    meta: {
      title: 'Crear Nueva Orden',
      auth: true,
    },
    component: CreateOrder
  },
  {
    path: '/create_multiple_orders',
    name: 'CreateMultipleOrders',
    meta: {
      title: 'Crear Ordenes',
      auth: true,
    },
    component: CreateMultipleOrders
  },
  {
    path: '/customer_fulfillment_edit_order/:id',
    name: 'CustomerEditPendingOrder',
    meta: {
      title: 'Editar Orden',
      auth: true,
    },
    component: CustomerEditPendingOrder
  },
  {
    path: '/customer_fulfillment_upload_label/:id',
    name: 'CustomerUpdateLabel',
    meta: {
      title: 'Editar Orden',
      auth: true,
    },
    component: CustomerUpdateLabel
  },
  {
    path: '/reports/stock',
    name: 'StockReport',
    meta: {
      title: 'Reportes - Existencias',
      auth: true,
    },
    component: StockReport
  },
  {
    path: '/reports/stocks',
    name: 'StockWithoutLocationReport',
    meta: {
      title: 'Reportes - Existencias',
      auth: true,
    },
    component: StockWithoutLocationReport
  },
  {
    path: '/reports/stocks_c',
    name: 'StockWithoutLocationReportCSide',
    meta: {
      title: 'Reportes - Existencias',
      auth: true,
    },
    component: StockWithoutLocationReportCSide
  },
  {
    path: '/reports/fulfillment_summary',
    name: 'FulfillmentSummary',
    meta: {
      title: 'Reportes - Resumen Fulfillment',
      auth: true,
    },
    component: FulfillmentSummary
  },
  {
    path: '/reports/balance_pallet',
    name: 'BalancePerPallet',
    meta: {
      title: 'Reportes - Saldos Por Tarima',
      auth: true,
    },
    component: BalancePerPallet
  },
  {
    path: '/reports/operations_by_customer',
    name: 'OperationsByCustomerReport',
    meta: {
      title: 'Reportes - Operaciones x Cliente',
      auth: true,
    },
    component: OperationsByCustomerReport
  },
  {
    path: '/reports/operations_by_customer_c',
    name: 'OperationsByCustomerCSideReport',
    meta: {
      title: 'Reportes - Operaciones',
      auth: true,
    },
    component: OperationsByCustomerCSideReport
  },

  {
    path: '/reports/cod_by_shipping_service',
    name: 'CODByShippingServiceReport',
    meta: {
      title: 'Reportes - COD por Paquetería',
      auth: true,
    },
    component: CODByShippingServiceReport
  },


  {
    path: '/reports/operations_by_product_c',
    name: 'OperationsByProductCSideReport',
    meta: {
      title: 'Reportes - Operaciones Por Producto',
      auth: true,
    },
    component: OperationsByProductCSideReport
  },
  {
    path: '/reports/products_by_fulfillment_c',
    name: 'ProductByFulfillmentCSideReport',
    meta: {
      title: 'Reportes - Operaciones Por Producto',
      auth: true,
    },
    component: ProductByFulfillmentCSideReport
  },
  {
    path: '/reports/boxes_per_fulfillment',
    name: 'BoxesPerFulfillment',
    meta: {
      title: 'Reportes - Cajas Por Orden',
      auth: true,
    },
    component: BoxesPerFulfillment
  },
  {
    path: '/reports/condensed_fulfillment',
    name: 'CondensedFulfillment',
    meta: {
      title: 'Reportes - Condensado Fulfillment',
      auth: true,
    },
    component: CondensedFulfillment
  },
  {
    path: '/reports/operations_by_product',
    name: 'OperationsByProductReport',
    meta: {
      title: 'Reportes - Operaciones x Producto',
      auth: true,
    },
    component: OperationsByProductReport
  },
  {
    path: '/reports/international_operations',
    name: 'InternationalOperationsReport',
    meta: {
      title: 'Reportes - Operaciones Internacionales',
      auth: true,
    },
    component: InternationalOperationsReport
  },
  {
    path: '/reports/products_by_fulfillment',
    name: 'ProductByFulfillmentReport',
    meta: {
      title: 'Reportes - Producto x Fulfillment',
      auth: true,
    },
    component: ProductByFulfillmentReport
  },
  {
    path: '/reports/history_product',
    name: 'HistoryProductReport',
    meta: {
      title: 'Producto - Historial',
      auth: true,
    },
    component: HistoryProductReport
  },

  {
    path: '/massive_annex_24',
    name: 'Annex24',
    meta: {
      title: 'Anexo 24 - Masivo',
      auth: true,
    },
    component: Annex24
  },
  {
    path: '/customs_patches/customs_documents',
    name: 'CustomsPatchesIndex',
    component: CustomsPatchesIndex,
    meta: {
      title: 'Anexo 24',
      auth: true,
    },
  },
  {
    path: '/customs_patches/details/:id',
    component: CustomsPatchesDetail,
    meta: {
      title: 'Detalles',
      auth: true,
    },
  },
  {
    path: '/customs_patches/reports/reports_discharges',
    component: CustomsPatchesDischargesReport,
    meta: {
      title: 'Reportes de descargos',
      auth: true,
    },
  },
  {
    path: '/customs_patches/reports/balance',
    component: CustomsPatchesBalanceReport,
    meta: {
      title: 'Reportes de saldos',
      auth: true,
    },
  },
  {
    path: '/customs_patches/reports/expiration',
    component: CustomsPatchesExpirationReport,
    meta: {
      title: 'Reportes de vencimientos',
      auth: true,
    },
  },
  {
    path: '/stuck_orders',
    name: 'OrdersPendingsIndex',
    meta: {
      title: 'Ordenes Pendientes',
      auth: true,
    },
    component: OrdersPendingsIndex
  },
  {
    path: '/stuck_external_orders',
    name: 'StuckExternalOrdersIndex',
    meta: {
      title: 'Ordenes Externas Atoradas',
      auth: true,
    },
    component: StuckExternalOrdersIndex
  },
  {
    path: '/stuck_external_orders/edit/:id',
    name: 'StuckExternalOrdersEdit',
    meta: {
      title: 'Ordenes Externas: Actualizar',
      auth: true,
    },
    component: StuckExternalOrdersEdit
  },
  {
    path: '/stuck_orders/complete/:id',
    name: 'OrdersPendingsComplete',
    meta: {
      title: 'Ordenes Pendientes - Completar Orden',
      auth: true,
    },
    component: OrdersPendingsComplete
  },
  {
    path: '/orders_possible_fraud',
    name: 'OrdersPossibleFraudIndex',
    meta: {
      title: 'Ordenes Posible Fraude',
      auth: true,
    },
    component: OrdersPossibleFraudIndex
  },
  {
    path: '/orders_possible_fraud/complete/:id',
    name: 'OrdersPossibleFraudComplete',
    meta: {
      title: 'Ordenes Posible Fraude - Completar Orden',
      auth: true,
    },
    component: OrdersPossibleFraudComplete
  },
  {
    path: '/liverpool/acceptance',
    name: 'LiverpoolAcceptance',
    meta: {
      title: 'Liverpool - Aceptación',
      auth: true,
    },
    component: LiverpoolAcceptance
  },
  {
    path: '/liverpool/confirmation',
    name: 'LiverpoolConfirmation',
    meta: {
      title: 'Liverpool - Confirmación',
      auth: true,
    },
    component: LiverpoolConfirmation
  },
  {
    path: '/liverpool/history',
    name: 'LiverpoolHistory',
    meta: {
      title: 'Liverpool - Historial',
      auth: true,
    },
    component: LiverpoolHistory
  },
  {
    path: '/reports/products_by_order',
    name: 'ProductByOrder',
    meta: {
      title: 'Reportes - Producto Por Categoría',
      auth: true,
    },
    component: ProductByOrder
  },
  {
    path: '/reports/annex_documents',
    name: 'AnnexDocuments',
    meta: {
      title: 'Reportes - Documento Anexo 24',
      auth: true,
    },
    component: AnnexDocuments
  },
  {
    path: '/services/create',
    name: 'ServicesCreate',
    meta: {
      title: 'Chronos - Servicios - Nuevo Servicio',
      auth: true,
    },
    component: ServicesCreate
  },
  {
    path: '/services/edit/:id',
    name: 'ServicesEdit',
    meta: {
      title: 'Chronos - Servicios - Editar Servicio',
      auth: true,
    },
    component: ServicesEdit
  },
  {
    path: '/services',
    name: 'ServicesIndex',
    meta: {
      title: 'Chronos - Servicios',
      auth: true,
    },
    component: ServicesIndex
  },
  {
    path: '/backlog',
    name: 'Backlog',
    meta: {
      title: 'Chronos - Backlog',
      auth: true,
    },
    component: Backlog
  },
  {
    path: '/tnt_extra_status',
    name: 'ExtraStatus',
    meta: {
      title: 'Chronos - Estatus Extra',
      auth: true,
    },
    component: ExtraStatus
  },
  {
    path: '/tnt_delivered',
    name: 'Delivered',
    meta: {
      title: 'Chronos - Entregados',
      auth: true,
    },
    component: Delivered
  },
  {
    path: '/tnt_delivered_details/:date/:client',
    name: 'DeliveredDetails',
    meta: {
      title: 'Chronos - Entregados',
      auth: true,
    },
    component: DeliveredDetails
  },
  {
    path: '/tnt_without_movement',
    name: 'WithoutMovement',
    meta: {
      title: 'Chronos - Sin Movimiento',
      auth: true,
    },
    component: WithoutMovement
  },
  {
    path: '/tnt_daily_cutoff',
    name: 'DailyCutoff',
    meta: {
      title: 'Chronos - Corte Diario',
      auth: true,
    },
    component: DailyCutoff
  },
  {
    path: '/tnt_rejections',
    name: 'Rejections',
    meta: {
      title: 'Chronos - Rechazos',
      auth: true,
    },
    component: Rejections
  },
  {
    path: '/tnt_closing_minute',
    name: 'ClosingMinute',
    meta: {
      title: 'Chronos - Acta de Cierre',
      auth: true,
    },
    component: ClosingMinute
  },
  {
    path: '/entrance/visitors',
    name: 'VisitorsIndex',
    meta: {
      title: 'Chronos - Visitantes',
      auth: true,
    },
    component: VisitorsIndex
  },
  {
    path: '/entrance/visitors/create/:id',
    name: 'VisitorsCreate',
    meta: {
      title: 'Chronos - Visitantes - Crear',
      auth: true,
    },
    component: VisitorsCreate
  },
  {
    path: '/entrance/visitors/create_schedule',
    name: 'VisitorsCreateSchedule',
    meta: {
      title: 'Chronos - Visitantes - Crear',
      auth: true,
    },
    component: VisitorsCreateSchedule
  },
  {
    path: '/entrance/visitors/edit/:id',
    name: 'VisitorsEdit',
    meta: {
      title: 'Chronos - Visitantes - Editar',
      auth: true,
    },
    component: VisitorsEdit
  },
  {
    path: '/entrance/visitors/detail/:id',
    name: 'VisitorsDetail',
    meta: {
      title: 'Chronos - Visitantes - Detalle',
      auth: true,
    },
    component: VisitorsDetail
  },
  {
    path: '/entrance/carriers',
    name: 'CarriersIndex',
    meta: {
      title: 'Chronos - Transportistas',
      auth: true,
    },
    component: CarriersIndex
  },
  {
    path: '/entrance/carriers/create',
    name: 'CarriersCreate',
    meta: {
      title: 'Chronos - Transportistas - Crear',
      auth: true,
    },
    component: CarriersCreate
  },
  {
    path: '/entrance/carriers/edit/:id',
    name: 'CarriersEdit',
    meta: {
      title: 'Chronos - Transportistas - Editar',
      auth: true,
    },
    component: CarriersEdit
  },
  {
    path: '/entrance/carriers/detail/:id',
    name: 'CarriersDetail',
    meta: {
      title: 'Chronos - Transportistas - Detalle',
      auth: true,
    },
    component: CarriersDetail
  },
  {
    path: '/entrance/attendances',
    name: 'AttendancesIndex',
    meta: {
      title: 'Chronos - Asistencias',
      auth: true,
    },
    component: AttendancesIndex
  },





  {
    path: '/advanced-fulfillment/pendings/eon',
    name: 'EAFPendings',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Pendientes',
      auth: true,
    },
    component: EAFPendings
  },
  {
    path: '/advanced-fulfillment/prepare/eon',
    name: 'EAFPrepare',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Pendientes',
      auth: true,
    },
    component: EAFPrepare
  },
  {
    path: '/advanced-fulfillment/to_be_supplied/eon',
    name: 'EAFFToBeSupplied',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Por Surtir',
      auth: true,
    },
    component: EAFFToBeSupplied
  },
  {
    path: '/advanced-fulfillment/supply/eon',
    name: 'EAFFSupply',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Surtir',
      auth: true,
    },
    component: EAFFSupply
  },
  {
    path: '/advanced-fulfillment/supplied/eon',
    name: 'EAFFSupplied',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Surtidas',
      auth: true,
    },
    component: EAFFSupplied
  },
  {
    path: '/advanced-fulfillment/sent/eon',
    name: 'EAFFSent',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Envíadas',
      auth: true,
    },
    component: EAFFSent
  },
  {
    path: '/advanced-fulfillment/returned/eon',
    name: 'EAFFReturned',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Retornos',
      auth: true,
    },
    component: EAFFReturned
  },





  {
    path: '/advanced-fulfillment/pendings/:shipping_service',
    name: 'AFPendings',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Pendientes',
      auth: true,
    },
    component: AFPendings
  },
  {
    path: '/advanced-fulfillment/prepare/:shipping_service',
    name: 'AFPrepare',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Pendientes',
      auth: true,
    },
    component: AFPrepare
  },
  {
    path: '/advanced-fulfillment/to_be_supplied/:shipping_service',
    name: 'AFToBeSupplied',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Por Surtir',
      auth: true,
    },
    component: AFToBeSupplied
  },
  {
    path: '/advanced-fulfillment/supply/:shipping_service',
    name: 'AFFSupply',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Surtir',
      auth: true,
    },
    component: AFFSupply
  },
  {
    path: '/advanced-fulfillment/supplied/:shipping_service',
    name: 'AFSupplied',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Surtidas',
      auth: true,
    },
    component: AFSupplied
  },
  {
    path: '/advanced-fulfillment/sent/:shipping_service',
    name: 'AFSent',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Enviadas',
      auth: true,
    },
    component: AFSent
  },
  {
    path: '/advanced-fulfillment/returned/:shipping_service',
    name: 'AFReturns',
    meta: {
      title: 'Chronos - Fulfllment Avanzado - Retornos',
      auth: true,
    },
    component: AFReturns
  },







  {
    path: '/ptl-fulfillment/pendings/:shipping_service',
    name: 'PendingsPtl',
    meta: {
      title: 'Chronos - Fulfllment Ptl - Pendientes',
      auth: true,
    },
    component: PendingsPtl
  },
  {
    path: '/ptl-fulfillment/prepare/:shipping_service',
    name: 'PreparePtl',
    meta: {
      title: 'Chronos - Fulfllment Ptl - Preparar',
      auth: true,
    },
    component: PreparePtl
  },
  {
    path: '/ptl-fulfillment/to-be-supplied/:shipping_service',
    name: 'ToBeSuppliedPtl',
    meta: {
      title: 'Chronos - Fulfllment Ptl - Por Surtir',
      auth: true,
    },
    component: ToBeSuppliedPtl
  },
  {
    path: '/ptl-fulfillment/supplied/:shipping_service',
    name: 'SuppliedPtl',
    meta: {
      title: 'Chronos - Fulfllment Ptl - Surtidas',
      auth: true,
    },
    component: SuppliedPtl
  },
  {
    path: '/ptl-fulfillment/sent/:shipping_service',
    name: 'SentPtl',
    meta: {
      title: 'Chronos - Fulfllment Ptl - Enviadas',
      auth: true,
    },
    component: SentPtl
  },
  {
    path: '/ptl-fulfillment/returned/:shipping_service',
    name: 'ReturnsPtl',
    meta: {
      title: 'Chronos - Fulfllment Ptl - Retornos',
      auth: true,
    },
    component: ReturnsPtl
  },
  {
    path: '/ptl-fulfillment/assemble',
    name: 'AssemblePtl',
    meta: {
      title: 'Chronos - Fulfllment Ptl - Armado',
      auth: true,
    },
    component: AssemblePtl
  },
  {
    path: '/external_shipments/pendings',
    name: 'PendingsEon',
    meta: {
      title: 'Chronos - Fulfllment Eon - Pendientes',
      auth: true,
    },
    component: PendingsEon
  },
  {
    path: '/external_shipments/create_with_label',
    name: 'CreateWithLabel',
    meta: {
      title: 'Chronos - Fulfllment Eon - Crear',
      auth: true,
    },
    component: CreateWithLabel
  },
  {
    path: '/external_shipments/edit_pending/:id',
    name: 'EditPendigEon',
    meta: {
      title: 'Chronos - Fulfllment Eon - Editar Pendiente',
      auth: true,
    },
    component: EditPendigEon
  },
  {
    path: '/external_shipments/in-process',
    name: 'InProcessEon',
    meta: {
      title: 'Chronos - Fulfllment Eon - En Proceso',
      auth: true,
    },
    component: InProcessEon
  },
  {
    path: '/external_shipments/sent',
    name: 'SentEon',
    meta: {
      title: 'Chronos - Fulfllment Eon - Enviadas',
      auth: true,
    },
    component: SentEon
  },
  {
    path: '/external_shipments/returns',
    name: 'ReturnsEon',
    meta: {
      title: 'Chronos - Fulfllment Eon - Retornos',
      auth: true,
    },
    component: ReturnsEon
  },
  {
    path: '/shipments_leirem/pendings',
    name: 'PendingsLeirem',
    meta: {
      title: 'Chronos - Fulfllment Leirem - Pendientes',
      auth: true,
    },
    component: PendingsLeirem
  },
  {
    path: '/shipments_leirem/in-process',
    name: 'InProcessLeirem',
    meta: {
      title: 'Chronos - Fulfllment Leirem - En Proceso',
      auth: true,
    },
    component: InProcessLeirem
  },
  {
    path: '/shipments_leirem/sent',
    name: 'SentLeirem',
    meta: {
      title: 'Chronos - Fulfllment Leirem - Enviadas',
      auth: true,
    },
    component: SentLeirem
  },
  {
    path: '/shipments_leirem/supply/:id',
    name: 'PrepareLeirem',
    meta: {
      title: 'Chronos - Fulfllment Leirem - Surtir',
      auth: true,
    },
    component: PrepareLeirem
  },
  {
    path: '/basic_search',
    name: 'BasicSearch',
    meta: {
      title: 'Chronos - Busqueda',
      auth: true,
    },
    component: BasicSearch
  },
  {
    path: '/consumables',
    name: 'ConsumablesIndex',
    meta: {
      title: 'Chronos - Consumibles',
      auth: true,
    },
    component: ConsumablesIndex
  },
  {
    path: '/consumables/create',
    name: 'ConsumablesCreate',
    meta: {
      title: 'Chronos - Consumibles - Ingresar Stock',
      auth: true,
    },
    component: ConsumablesCreate
  },
  {
    path: '/guides',
    name: 'Guides',
    meta: {
      title: 'Chronos - Guías',
      auth: false,
    },
    component: Guides
  },
  {
    path: '/guide-details/:id',
    name: 'GuideDetail',
    meta: {
      title: 'Chronos - Guías - Detalle',
      auth: false,
    },
    component: GuideDetail
  },
  {
    path: '/c-guides',
    name: 'GuidesCustomerSide',
    meta: {
      title: 'Chronos - Guías',
      auth: false,
    },
    component: GuidesCustomerSide
  },
  {
    path: '/guide-sales',
    name: 'GuideSales',
    meta: {
      title: 'Chronos - Guías',
      auth: false,
    },
    component: GuideSales
  },
  {
    path: '/customers/edit/guides_fees/:id',
    name: 'CustomerEditGuidesFees',
    meta: {
      title: 'Chronos - Guías - Cuotas',
      auth: false,
    },
    component: CustomerEditGuidesFees
  },
  {
    path: '/stations',
    name: 'StationsIndex',
    meta: {
      title: 'Chronos - Estaciones',
      auth: true,
    },
    component: StationsIndex
  },
  {
    path: '/c-pickup-addresses',
    name: 'PickupAddressesCustomerSide',
    meta: {
      title: 'Chronos - Direcciones de pickup',
      auth: false,
    },
    component: PickupAddressesCustomerSide
  },
  {
    path: '/station/edit/:id',
    name: 'EditStation',
    meta: {
      title: 'Chronos - Estaciones - Editar Estación',
      auth: true,
    },
    component: EditStation
  },
  {
    path: '/stations/create',
    name: 'CreateStation',
    meta: {
      title: 'Chronos - Estaciones - Crear Estación',
      auth: true,
    },
    component: CreateStation
  },
  {
    path: '/slots',
    name: 'SlotsIndex',
    meta: {
      title: 'Chronos - Slots',
      auth: true,
    },
    component: SlotsIndex
  },
  {
    path: '/slots/create',
    name: 'CreateSlot',
    meta: {
      title: 'Chronos - Slots - Crear Slot',
      auth: true,
    },
    component: CreateSlot
  },
  {
    path: '/totes',
    name: 'TotesIndex',
    meta: {
      title: 'Chronos - Totes',
      auth: true,
    },
    component: TotesIndex
  },
  {
    path: '/totes/create',
    name: 'CreateTote',
    meta: {
      title: 'Chronos - Totes - Crear Tote',
      auth: true,
    },
    component: CreateTote
  },
  {
    path: '/tote/edit/:id',
    name: 'EditTote',
    meta: {
      title: 'Chronos - Totes - Editar Tote',
      auth: true,
    },
    component: EditTote
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
